var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoHuiskesKokkeler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 211.112,
    height: 53.397,
    viewBox: "0 0 211.112 53.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "1nl7m5wnka",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f34b15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopColor: "#f75c0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8000"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 147"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 85",
    d: "M39.1.2v5.079H28.6V.2h-4.4v12.416h4.4v-5.3h10.5v5.3h4.345V.2z",
    transform: "translate(-10.543 5.08)",
    style: {
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 86",
    d: "M84.249.2V9c0 3.5-3.95 3.725-9.481 3.725-5.3 0-9.368-.226-9.368-3.725V.2h4.345V9c0 1.3.847 1.693 5.023 1.693C78.775 10.7 79.9 10.358 79.9 9V.2h4.345",
    transform: "translate(-28.492 5.08)",
    style: {
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 87",
    d: "M105.8 12.616h4.345V.2H105.8z",
    transform: "translate(-46.092 5.08)",
    style: {
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 88",
    d: "M123.145 8.578v.564c0 1.467 1.129 1.524 5.136 1.524 3.95 0 4.515-.4 4.515-1.806 0-1.806-1.749-1.58-5.136-1.637-4.853-.169-8.747-.113-8.747-3.725 0-3.386 3.95-3.5 9.368-3.5 4.628 0 8.409.056 8.409 3.33v.4h-4.345v-.4c0-1.3-1.016-1.354-4.063-1.354-4.345 0-5.023.226-5.023 1.524 0 1.524.564 1.58 4.966 1.749 7 .226 8.917.451 8.917 3.612 0 3.5-3.047 3.781-8.86 3.781-5.023 0-9.481.056-9.481-3.5v-.562h4.345",
    transform: "translate(-51.756 5.167)",
    style: {
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 89",
    d: "M160.945 5.279h2.032L170.539.2h5.3L166.7 6.238l10.1 6.377h-5.531l-8.3-5.3h-2.032v5.3H156.6V.2h4.345z",
    transform: "translate(-68.224 5.08)",
    style: {
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 90",
    d: "M198.645 5.336h10.61v1.975h-10.61v3.273h11.287v2.032H194.3V.2h15.519v2.032h-11.174z",
    transform: "translate(-84.648 5.08)",
    style: {
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91",
    d: "M230.545 8.578v.564c0 1.467 1.129 1.524 5.136 1.524 3.95 0 4.515-.4 4.515-1.806 0-1.806-1.693-1.58-5.079-1.637-4.91-.169-8.8-.113-8.8-3.725 0-3.386 3.95-3.5 9.368-3.5 4.628 0 8.409.056 8.409 3.33v.4h-4.345v-.4c0-1.3-1.016-1.354-4.063-1.354-4.289 0-5.023.226-5.023 1.524 0 1.524.621 1.58 5.023 1.749 6.941.226 8.86.451 8.86 3.612 0 3.5-2.991 3.781-8.86 3.781-5.023 0-9.481.056-9.481-3.5v-.562h4.345",
    transform: "translate(-98.545 5.167)",
    style: {
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 92",
    d: "M4.345 37.379h2.032l7.562-5.079H19.3l-9.2 6.095 10.1 6.321h-5.471l-8.352-5.3H4.345v5.3H0V32.3h4.345z",
    transform: "translate(0 -8.905)",
    style: {
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 93",
    d: "M41.145 36.671V40c0 2.483.9 2.709 5.248 2.709 3.95 0 5.3-.282 5.3-2.709v-3.33c.113-2.37-1.467-2.54-5.3-2.54-4.684 0-5.136.564-5.248 2.54m14.9 0V40c0 4.007-2.822 4.74-9.65 4.74-7 0-9.594-.677-9.594-4.74v-3.33c0-3.894 2.427-4.571 9.594-4.571 6.546 0 9.65.564 9.65 4.571",
    transform: "translate(-16.032 -8.818)",
    style: {
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 94",
    d: "M80.9 37.379h1.975l7.564-5.079H95.8l-9.2 6.095 10.16 6.321h-5.531l-8.352-5.3H80.9v5.3h-4.4V32.3h4.4z",
    transform: "translate(-33.328 -8.905)",
    style: {
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 95",
    d: "M119.145 37.379h2.032l7.562-5.079h5.361l-9.2 6.095 10.1 6.321h-5.474l-8.352-5.3h-2.032v5.3H114.8V32.3h4.345z",
    transform: "translate(-50.013 -8.905)",
    style: {
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 96",
    d: "M156.945 37.436h10.61v1.975h-10.61v3.273h11.23v2.032H152.6V32.3h15.519v2.032h-11.174z",
    transform: "translate(-66.481 -8.905)",
    style: {
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 97",
    d: "M190.545 42.684h10.61v2.032H186.2V32.3h4.345z",
    transform: "translate(-81.119 -8.905)",
    style: {
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 98",
    d: "M220.3 37.436h10.553v1.975H220.3v3.273h11.23v2.032H215.9V32.3h15.576v2.032H220.3z",
    transform: "translate(-94.058 -8.905)",
    style: {
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 99",
    d: "M259.4 38.564c3.217 0 4.007-.339 4.007-2.145 0-1.749-.564-2.088-3.668-2.088H253.7v4.233zm-5.7 2.036v4.12h-4.4V32.3h11.569c4.966.056 6.885.9 6.885 3.725 0 1.862-.169 3.217-4.007 3.5v.056c3.047.169 3.838 1.072 3.838 2.822v2.314h-4.345V42.4c0-1.016-.79-1.749-2.878-1.806z",
    transform: "translate(-108.609 -8.905)",
    style: {
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 100",
    d: "m43.971 69.608-2.257 3.386h4.571zm-2.54 3.95-.79 1.185H39.4l3.725-5.643h1.637l3.838 5.643h-1.186l-.847-1.185z",
    transform: "translate(-17.165 -24.937)",
    style: {
      opacity: 0.5,
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 101",
    d: "M72.927 69.1v4.063c0 1.524-1.637 1.637-4.063 1.637-2.257 0-4.063-.056-4.063-1.637V69.1h1.185v4.063c0 .9.4 1.072 2.878 1.072 2.088 0 2.878-.056 2.878-1.072V69.1h1.185",
    transform: "translate(-28.23 -24.937)",
    style: {
      opacity: 0.5,
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 102",
    d: "M92.758 74.743h-1.185v-5.079H88.3V69.1h7.788v.564h-3.33z",
    transform: "translate(-38.468 -24.937)",
    style: {
      opacity: 0.5,
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 103",
    d: "M113.73 69.564c-1.693 0-2.145.226-2.145 1.354v1.975c0 1.129.621 1.242 2.145 1.3h1.354c1.524-.056 2.2-.169 2.2-1.3v-1.974c0-1.129-.451-1.354-2.2-1.354zm1.354-.564c2.6.056 3.33.508 3.33 1.919v1.975c0 1.354-.847 1.862-3.33 1.862h-1.354c-2.427 0-3.33-.508-3.33-1.862v-1.975c0-1.411.79-1.862 3.33-1.919z",
    transform: "translate(-48.096 -24.893)",
    style: {
      opacity: 0.5,
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 104",
    d: "M142.409 71.878v1.242c0 1.3-1.072 1.637-3.386 1.637h-1.129c-2.709 0-3.894-.282-3.894-2.032v-1.75c0-1.524 1.242-1.975 2.991-1.975h2.652c1.58 0 2.765.339 2.765 1.3v.4h-1.185v-.282c0-.677-.451-.847-2.145-.847h-1.411c-2.2 0-2.54.282-2.54 1.467v1.806c0 1.072.677 1.354 2.54 1.354h1.133c2.032 0 2.483-.169 2.483-1.072v-.677h-3.273v-.564h4.4",
    transform: "translate(-58.378 -24.893)",
    style: {
      opacity: 0.5,
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105",
    d: "M163.34 71.922c1.806-.056 2.032-.339 2.032-1.242 0-.734-.169-1.016-2.032-1.016h-3.555v2.257zm-3.555 2.822H158.6V69.1h4.74c2.2 0 3.16.339 3.16 1.637 0 .79-.169 1.354-1.749 1.467 1.129.056 1.637.451 1.637 1.016v1.524H165.2v-1.186c0-.734-.282-1.072-1.693-1.072h-3.725v2.257z",
    transform: "translate(-69.095 -24.937)",
    style: {
      opacity: 0.5,
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 106",
    d: "M185.53 69.564c-1.749 0-2.2.226-2.2 1.354v1.975c0 1.129.677 1.242 2.2 1.3h1.354c1.524-.056 2.145-.169 2.145-1.3v-1.974c0-1.129-.451-1.354-2.145-1.354zm1.354-.564c2.54.056 3.33.508 3.33 1.919v1.975c0 1.354-.9 1.862-3.33 1.862h-1.354c-2.483 0-3.33-.508-3.33-1.862v-1.975c0-1.411.734-1.862 3.33-1.919z",
    transform: "translate(-79.376 -24.893)",
    style: {
      opacity: 0.5,
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 107",
    d: "M206.785 71.583h5.192v.508h-5.192v2.088h5.415v.564h-6.6V69.1h6.6v.564h-5.418z",
    transform: "translate(-89.571 -24.937)",
    style: {
      opacity: 0.5,
      fill: "#010c26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108",
    d: "M228.029 69.664v2.314h2.991c1.58 0 2.37 0 2.37-1.072s-.4-1.242-1.806-1.242zM226.9 69.1h5.192c1.975 0 2.427.734 2.427 1.693 0 .508 0 1.749-2.483 1.749h-4.007v2.2H226.9V69.1z",
    transform: "translate(-98.85 -24.937)",
    style: {
      opacity: 0.5,
      fill: "#010c26"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 110",
    d: "m5090.919 443.052 25.849-52.062",
    transform: "translate(-4907 -390.323)",
    style: {
      fill: "url(#1nl7m5wnka)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 110 - Outline",
    d: "m5092.263 443.719-2.687-1.334 25.849-52.062 2.688 1.334z",
    transform: "translate(-4907 -390.323)",
    style: {
      fill: "url(#1nl7m5wnka)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHuiskesKokkeler);
export default __webpack_public_path__ + "static/media/logo-huiskes-kokkeler.8fdb258d739fc61d41ce6426ae5835d0.svg";
export { ForwardRef as ReactComponent };